import React, { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import CustomSelect from "../components/CustomSelect";
import avai from "../assets/avai.png";
import sicko from "../assets/sicko.png";
import aleph from "../assets/aleph.png";
import avax from "../assets/avalanche.svg";
import usdt from "../assets/USDT.png";
import usdc from "../assets/usdc.png";
import Hopepepe from "../assets/logo.png";
import {
  AVX_Address,
  FACTORY_Contract_Abi,
  FACTORY_Contract_Address,
  HopePepe_Contract_Address,
  HopePepePairABI,
  USDC_Contract_Address,
  USDT_Contract_Address,
} from "../utilies/constant";
import useGetAmountOut from "../hooks/useGetAmountOut";
import { ethers } from "ethers";
import { useAccount } from "wagmi";
import { Tokens, tokensImages } from "../Constant";

const ImportModal = ({
  isOpen,
  setIsImportModalOpen,
  selectPair,
  setselectPair,
  setActiveTab,
  setIsRemovedLiquidity,
  setremoveLiquidityValue,
}) => {
  const [activeButton, setActiveButton] = useState(null);
  const [selectedFromToken, setSelectedFromToken] = useState(
    Object.keys(selectPair).length > 0
      ? {
          name: selectPair?.TokenAName,
          img: tokensImages[selectPair?.TokenAName],
        }
      : {
          name: "Select a currency",
          img: null,
        }
  );
  const [selectedToToken, setSelectedToToken] = useState(
    selectPair?.TokenAName
      ? {
          name: selectPair?.TokenBName,
          img: tokensImages[selectPair?.TokenBName],
        }
      : {
          name: "Select a currency",
          img: null,
        }
  );
  const [contractAddresses, setContractAddresses] = useState(
    Object.keys(selectPair).length > 0
      ? [selectPair?.TokenAAddress, selectPair?.TokenBAddress]
      : []
  );
  const { address } = useAccount();

  useEffect(() => {
    if (selectPair && Object.keys(selectPair).length > 0) {
      setSelectedToToken({
        name: selectPair?.TokenBName,
        img: tokensImages[selectPair?.TokenBName],
      });
      setSelectedFromToken({
        name: selectPair?.TokenAName,
        img: tokensImages[selectPair?.TokenAName],
      });
      setContractAddresses([
        selectPair?.TokenAAddress,
        selectPair?.TokenBAddress,
      ]);
    }
  }, [JSON.stringify(selectPair), isOpen]);
  const {
    tokenBlnc: pairValue,
    refetch,
    isLoading,
  } = useGetAmountOut(
    FACTORY_Contract_Address,
    FACTORY_Contract_Abi,
    0,
    "getPair",
    [contractAddresses[0], contractAddresses[1]]
  );

  const { tokenBlnc: totalSupply, refetch: refetchtotalSupply } =
    useGetAmountOut(pairValue, HopePepePairABI, pairValue, "totalSupply", []);

  const { tokenBlnc: balanceOf, refetch: refetchBalance } = useGetAmountOut(
    pairValue,
    HopePepePairABI,
    totalSupply,
    "balanceOf",
    [address]
  );
  const { tokenBlnc: reserves, refetch: refetchReserves } = useGetAmountOut(
    pairValue,
    HopePepePairABI,
    balanceOf,
    "getReserves",
    []
  );

  useEffect(() => {
    refetch();
    if (pairValue) {
      refetchtotalSupply();
    }
    if (totalSupply) {
      refetchBalance();
      refetchReserves();
    }
  }, [
    totalSupply,
    pairValue,
    contractAddresses,
    selectedFromToken,
    selectedToToken,
    selectPair,
    isOpen,
  ]);

  useEffect(() => {
    refetch();
    refetchtotalSupply();

  }, [isOpen]);

  const handleTokenSelect = (token) => {
    if (activeButton === "from") {
      setSelectedFromToken(token);
      handleAddContractAdress("from", token);
    } else if (activeButton === "to") {
      setSelectedToToken(token);
      handleAddContractAdress("to", token);
    }
    refetch();
  };

  const handleAddContractAdress = (type, token) => {
    if (type === "from") {
      setContractAddresses((prevAddresses) => {
        const updatedAddresses = [token?.ContractAddress];
        // Add the "to" address if it's already selected and isn't the same as "from"
        if (
          selectedToToken.ContractAddress &&
          selectedToToken.ContractAddress !== token?.ContractAddress
        ) {
          updatedAddresses.push(selectedToToken.ContractAddress);
        }
        return updatedAddresses;
      });
    } else {
      setContractAddresses((prevAddresses) => {
        const updatedAddresses = prevAddresses.slice(); // Create a shallow copy
        // Ensure "from" address is first and "to" address is second
        updatedAddresses[1] = token?.ContractAddress;
        // if (updatedAddresses[0] === selectedFromToken?.ContractAddress) {
        // } else {
        //   updatedAddresses.push(token?.ContractAddress);
        // }
        return updatedAddresses;
      });
    }
  };

  const handleClose = () => {
    setIsImportModalOpen(false);
    setIsRemovedLiquidity(false);
    setselectPair({});
    setSelectedFromToken({ name: "Select a currency", img: null });
    setSelectedToToken({ name: "Select a currency", img: null });
    setContractAddresses([]);

    // Reset state values
    refetch(); // Trigger a fresh fetch if needed
  };


  const filteredTokens = Tokens.filter((token) => {
    if (activeButton === "from") {
      return token.symbol !== selectedToToken.name;
    } else {
      return token.symbol !== selectedFromToken.name;
    }
  });

  const handleTokenClick = (token) => {
    handleTokenSelect({
      name: token.symbol,
      img: token.img,
      ContractAddress: token?.ContractAddress,
      type: token?.type,
    });
  };

  const getPrecentageValue = (totalValue, balance) => {
    if (totalValue && balance) {
      let totalAmount = ethers.utils.formatUnits(totalValue?.toString() || "0");
      let balanceAmount = ethers.utils.formatUnits(balance?.toString() || "0");

      let calculateTotal = Number(balanceAmount) / Number(totalAmount);
      calculateTotal = Number(calculateTotal) * 100;
      return parseInt(calculateTotal);
    }
  };

  const pooledValue = (TokenSupply, TokenBalance, TotalReserve) => {
    if (TokenSupply && TokenBalance && TotalReserve) {
      let totalAmount = ethers.utils.formatUnits(
        TokenSupply?.toString() || "0"
      );
      let balanceAmount = ethers.utils.formatUnits(
        TokenBalance?.toString() || "0"
      );
      let TotalReserveA = ethers.utils.formatUnits(
        TotalReserve[0]?.toString() || "0"
      );
      let TotalReserveB = ethers.utils.formatUnits(
        TotalReserve[1]?.toString() || "0"
      );
      let shareValue = Number(balanceAmount) / Number(totalAmount);
      let PooledTokenA = Number(shareValue) * TotalReserveA;
      let PooledTokenB = Number(shareValue) * TotalReserveB;
      return {
        PooledTokenA: parseFloat(PooledTokenA || 0).toFixed(3),
        PooledTokenB: parseFloat(PooledTokenB || 0).toFixed(3),
      };
    }
  };

  let userLiquidity=getPrecentageValue(totalSupply, balanceOf)
  const isDisabled =
    pairValue == "0x0000000000000000000000000000000000000000" ||
    totalSupply == undefined ||
    totalSupply == 0 ||userLiquidity==0 || userLiquidity == undefined

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-gray-800 rounded-lg shadow-lg py-6 w-96">
          <div className="px-6 border-b-[1px] border-[#505050] mb-5">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-white text-lg font-semibold">Pool Details</h2>
              <button
                onClick={handleClose}
                className="text-gray-400 text-[18px] hover:text-white"
              >
                <RxCross2 />
              </button>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Import an existing pool
            </p>
          </div>

          <div className="px-6">
            <div className="space-y-4">
              <div
                className="flex items-center space-x-2"
                onClick={() => setActiveButton("from")}
              >
                <CustomSelect
                  options={filteredTokens}
                  selected={selectedFromToken}
                  onSelect={handleTokenClick}
                />
              </div>
              <div className="text-center text-[18px] text-[#fff]">+</div>
              <div
                className="flex items-center space-x-2"
                onClick={() => setActiveButton("to")}
              >
                <CustomSelect
                  options={filteredTokens}
                  selected={selectedToToken}
                  onSelect={handleTokenClick}
                />
              </div>
            </div>

            <div className="bg-gray-700 text-white rounded-lg p-4 mt-6">
              <h3 className="text-sm text-[green] font-semibold mb-2 ">
                LP tokens in your wallet
              </h3>
              <div className="text-sm">
                <div className="flex items-center justify-between mb-2">
                  <p className="flex items-center gap-1">
                    {selectedFromToken?.img && (
                      <img
                        src={selectedFromToken?.img}
                        className="w-6 h-6 rounded-full"
                      />
                    )}
                    {selectedToToken?.img && (
                      <img
                        src={selectedToToken?.img}
                        className="w-6 h-6 rounded-full"
                      />
                    )}
                    {`${selectedFromToken?.name} - ${selectedToToken?.name}`} :
                  </p>
                  <span>
                    {isLoading
                      ? "Loading.."
                      : parseFloat(
                          ethers.utils.formatUnits(
                            totalSupply?.toString() || "0"
                          )
                        ).toFixed(3) || "0"}
                  </span>
                </div>
                <p className="flex items-center justify-between mb-2">
                  Share in Trading Pair:{" "}
                  <span>
                    {getPrecentageValue(totalSupply, balanceOf) || 0} %
                  </span>
                </p>
                <p className="flex items-center justify-between mb-2">
                  Pooled {selectedFromToken?.name || ""}:
                  <span>
                    {pooledValue(totalSupply, balanceOf, reserves)
                      ?.PooledTokenB || 0}
                  </span>
                </p>
                <p className="flex items-center justify-between">
                  Pooled {selectedToToken?.name || ""}:{" "}
                  <span>
                    {pooledValue(totalSupply, balanceOf, reserves)
                      ?.PooledTokenA || 0}
                  </span>
                </p>
              </div>
            </div>

            <div className="flex justify-between gap-2">
              <button
                className={`w-full mt-4 px-[20px] h-[46px] bg-[green]
                        ${
                          (selectedFromToken?.img == null ||
                            selectedToToken?.img == null) &&
                          "bg-[lightgreen]"
                        } rounded-[10px] flex items-center justify-center text-[#fff]`}
                onClick={() => {
                  handleClose();
                  setActiveTab(true);
                  if (Object.keys(selectPair).length > 0) {
                    setremoveLiquidityValue(selectPair);
                  } else {
                    let pairObject = {
                      PairAddress: pairValue,
                      TokenAAddress: contractAddresses[0],
                      TokenAName: selectedFromToken?.name,
                      TokenBAddress: contractAddresses[1],
                      TokenBName: selectedToToken?.name,
                      UserAddress: address,
                    };
                    setremoveLiquidityValue(pairObject);
                  }
                }}
                disabled={
                  selectedFromToken?.img == null || selectedToToken?.img == null
                }
              >
                Add Liquidity
              </button>

              <button
                className={`w-full mt-4 px-[20px] h-[46px] bg-[green]

                  ${
                    (selectedFromToken?.img == null ||
                      selectedToToken?.img == null ||
                      isDisabled) &&
                    "bg-[lightgreen]"
                  } rounded-[10px] flex items-center justify-center text-[#fff]`}
                onClick={() => {
                  handleClose();
                  setIsRemovedLiquidity(true);
                  if (Object.keys(selectPair).length > 0) {
                    setremoveLiquidityValue(selectPair);
                  } else {
                    let pairObject = {
                      PairAddress: pairValue,
                      TokenAAddress: contractAddresses[0],
                      TokenAName: selectedFromToken?.name,
                      TokenBAddress: contractAddresses[1],
                      TokenBName: selectedToToken?.name,
                      UserAddress: address,
                    };
                    setremoveLiquidityValue(pairObject);
                  }
                }}
                disabled={
                  selectedFromToken?.img == null ||
                  selectedToToken?.img == null ||
                  isDisabled
                }
              >
                Remove Liquidity
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportModal;
